module.exports = __webpack_public_path__ + "static/media/fog-day.9ffdfd76.svg";